module.exports = __webpack_public_path__ + "static/media/superman@3x.2dd467d0.png";